import Icon from "components/Icon"
import { Fragment } from "react"
import Arrow from "public/assets/blue-arrow.svg"

export default function FeeIconSection({ blok }) {
  return (
    <section className="bg-blueWeave bg-center overflow-hidden mb-4 prose-h2:text-white">
      {blok?.heading ? <h2 className="pt-12 text-center px-5">{blok?.heading}</h2> : null}
      <div className="flex flex-col lg:flex-row gap-8 py-12 px-5 justify-between items-center max-w-screen-xl mx-auto">
        {blok?.icons.map((card, idx) => (
          <Fragment key={card?._uid}>
            <div className="group flex flex-col items-center max-w-[250px] gap-4">
              <Icon icon={card.icon} className="mx-auto" />
              <h4 className="text-white text-center">{card.label}</h4>
            </div>
            {idx !== blok?.icons.length - 1 ? (
              <div className="relative">
                <Arrow className="rotate-90 lg:rotate-0 h-8 lg:h-6 relative lg:absolute lg:top-1/2 lg:-translate-y-10 left-1/2 -translate-x-1/2" />
              </div>
            ) : null}
          </Fragment>
        ))}
      </div>
      <div className="before:content-[''] before:absolute before:w-screen before:h-full before:bg-primary before:mix-blend-multiply before:bg-opacity-60 relative overflow-hidden prose-h3:py-8">
        {blok?.promise_heading ? (
          <h3 className="text-white relative text-center px-5">{blok?.promise_heading}</h3>
        ) : null}
      </div>
    </section>
  )
}
